import { useStore } from 'vuex';
import { computed } from 'vue';

export function useLoading() {
    const store = useStore();
    const isLoading = computed(() => store.getters['global_loading/getLoadingStatus']);

    const showLoading = () => {
        store.dispatch('global_loading/changeLoadingStatus', true);
    };

    const hideLoading = () => {
        store.dispatch('global_loading/changeLoadingStatus', false);
    };

    return {
        isLoading,
        showLoading,
        hideLoading,
    };
}
